module.exports = __webpack_public_path__ + "static/img/Logo16_Pencils.dab81c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo16_Pencils.png
// module id = 306
// module chunks = 2